import type { CommonSVGProps } from './helpers';

export const EmptyTaskCard = (props: CommonSVGProps) => (
  <svg
    fill="none"
    height={60}
    width={148}
    {...props}
  >
    <rect
      fill="#EFEFEF"
      fillOpacity={1}
      height={60}
      rx={8}
      width={148}
    />
    <rect
      fill="#DCDCDC"
      fillOpacity={1}
      height={5}
      rx={2.5}
      width={136}
      x={6}
      y={9}
    />
    <rect
      fill="#DCDCDC"
      fillOpacity={1}
      height={5}
      rx={2.5}
      width={66}
      x={6}
      y={18}
    />
  </svg>
);
